import React, { useState, useEffect } from "react";
import "./Slider.css";

const Slider = ({
  images,
  autoPlay = false,
  autoPlayInterval = 3000,
  dots,
  styles,
  mainstyle,
  extraClasses,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hover, setHover] = useState(false);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    if (autoPlay) {
      const interval = setInterval(() => {
        nextSlide();
      }, autoPlayInterval);
      return () => clearInterval(interval);
    }
  }, [autoPlay, autoPlayInterval, currentIndex]);

  return (
    <div
      className="slider bxShadow"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ ...mainstyle }}
    >
      <div
        className={`slider-image-wrapper ${extraClasses || ""}`}
        style={{
          ...styles,
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: "transform 0.5s ease-in-out",
        }}
      >
        {images &&
          images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Slide ${index + 1}`}
              className="slider-image"
              loading="lazy"
            />
          ))}
      </div>

      {hover && (
        <>
          <button className="slider-button left" onClick={prevSlide}>
            &#8249;
          </button>
          <button className="slider-button right" onClick={nextSlide}>
            &#8250;
          </button>
        </>
      )}

      {dots && (
        <div className="slider-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "dot-active" : ""}`}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Slider;
